<script>
import { PostalNames } from '../../constants/PortalNames.js'

export default {
  props: {
    disableAnimation: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      PostalNames,
      portalTarget: PostalNames.SlideOutContainer // Default to first layer
    }
  },
  created () {
    // Use setTimeout to ensure DOM is updated from any parent renders
    setTimeout(() => {
      const newTarget = this.getAvailablePortalTarget()
      if (newTarget !== this.portalTarget) {
        this.portalTarget = newTarget
      }
    }, 10)
  },
  mounted () {
    this.$nextTick(() => {
      this.adjustHeightToParent()
    })
  },
  methods: {
    getAvailablePortalTarget () {
      const layers = [
        PostalNames.SlideOutContainer,
        PostalNames.SlideOutContainerLayer1,
        PostalNames.SlideOutContainerLayer2,
        PostalNames.SlideOutContainerLayer3
      ]

      // Count existing containers to determine next available layer
      const existingContainers = document.querySelectorAll('.slide-out-container-portal')
      const nextLayerIndex = existingContainers.length % layers.length

      return layers[nextLayerIndex]
    },
    adjustHeightToParent () {
      // Wait a bit for portal to render, then find all slide-out containers
      setTimeout(() => {
        const allContainers = document.querySelectorAll('.slide-out-container-portal')

        if (allContainers.length <= 1) return // No parent containers

        // Find the current container (should be the last one)
        const currentContainer = allContainers[allContainers.length - 1]

        // Find the maximum height from all parent containers
        let maxParentHeight = 0
        for (let i = 0; i < allContainers.length - 1; i++) {
          const parentContainer = allContainers[i]
          const parentHeight = Math.max(parentContainer.scrollHeight, parentContainer.offsetHeight)
          maxParentHeight = Math.max(maxParentHeight, parentHeight)
        }

        // Set min-height to match the tallest parent
        if (maxParentHeight > 0) {
          currentContainer.style.minHeight = `${maxParentHeight}px`
        }
      }, 100)
    }
  },
  render (createElement) {
    // Get the default slot's children
    const defaultSlot = this.$slots.default

    // If no slot content, don't render anything
    if (!defaultSlot || defaultSlot.length === 0) {
      return null
    }

    // Check if there is at least one child in the default slot
    if (defaultSlot && defaultSlot.length === 1) {
      let props = {}

      const { staticClass, ...restProps } = defaultSlot[0].data ?? {}

      props = {
        class: [staticClass, 'slide-out-container-portal', this.className, this.loading ? 'loading' : ''].filter(Boolean),
        ...restProps
      }

      const clonedChild = createElement(
        defaultSlot[0].tag,
        props,
        defaultSlot[0].children
      )

      const content = this.disableAnimation
        ? createElement('div', { class: ['slide-out-container-portal', this.className, this.loading ? 'loading' : ''].filter(Boolean) }, [clonedChild])
        : createElement(
          'transition',
          {
            props: {
              name: 'show',
              appear: true
            }
          },
          [clonedChild]
        )

      return createElement(
        'portal',
        {
          props: {
            to: this.portalTarget
          }
        },
        [content]
      )
    } else {
      // If there is no child or more than one child, just return the original slot content
      const content = createElement('div', { class: ['slide-out-container-portal', this.className, this.loading ? 'loading' : ''].filter(Boolean) }, this.$slots.default)

      return createElement(
        'portal',
        {
          props: {
            to: this.portalTarget
          }
        },
        [content]
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-out-container-portal {
  width: 100%;
  min-height: -webkit-fill-available;
  background: #F3F5F7;
  position: absolute;
  padding: 40px;
  top: 0;
  left: 0;
  z-index: calc($navigationMenuZIndex - 2);
  margin-left: 0;
}
.show-enter-active,
.show-leave-active,
.show-appear-active {
  transition: margin-left 0.5s;
}
.show-enter,
.show-appear {
  margin-left: 100%;
}
.show-enter-to,
.show-appear-to {
  margin-left: 0;
}
.show-leave {
  margin-left: 0;
}
.show-leave-to {
  margin-left: 100%;
}
</style>

<style>
.content:has(.slide-out-container-portal.show-leave-active),
.content:has(.slide-out-container-portal.show-enter-active) {
  overflow-x: clip;
}

</style>
